import React from 'react';

interface AfterHoursPromptFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const AfterHoursPromptField: React.FC<AfterHoursPromptFieldProps> = ({ value, onChange }) => (
  <div className="border-t border-gray-200 pt-6 space-y-2">
    <label htmlFor="after-hours-prompt" className="block text-sm font-medium text-gray-900">
      After-hours prompt (optional)
    </label>
    <p id="after-hours-prompt-help" className="text-sm text-gray-500">
      Add instructions for when your company is closed. The bot uses your hours and timezone
      above and your public holidays, then returns to its normal instructions when you reopen. Company information and
      conversation history stay available. Leave blank to disable.
    </p>
    <textarea
      id="after-hours-prompt"
      aria-describedby="after-hours-prompt-help"
      value={value}
      onChange={event => onChange(event.target.value)}
      rows={5}
      placeholder="Explain when we reopen, collect the customer's details and enquiry, and avoid promising immediate staff assistance."
      className="block w-full rounded-md border border-gray-300 p-3 text-sm shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
    />
    <p className="text-xs text-gray-500">
      Applies to AI replies, including Test Chat. Automated triggers keep their existing behaviour.
    </p>
  </div>
);

export default AfterHoursPromptField;
